import { lazy } from 'react';

const CourseEnrollmentsPage = lazy(() => import('../pages/CourseEnrollments.page'));
const ProductEnrollmentsPage = lazy(() => import('../pages/ProductEnrollments.page'));

const EnrollmentsRoutes = [
    {
        path: '/enrollments',
        children: [
            {
                path: 'course-enrollments',
                element: <CourseEnrollmentsPage />,
                layout: 'default',
                isAuthReq: true,
            },
            {
                path: 'product-enrollments',
                element: <ProductEnrollmentsPage />,
                layout: 'default',
                isAuthReq: true,
            },
        ],
    },
];

export { EnrollmentsRoutes };
